module.exports = __webpack_public_path__ + "static/img/add_kjdy_success.22c23d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/add_kjdy_success.png
// module id = 1211
// module chunks = 0